:host {
  height: 100%;
}